import { localStorageHelper } from '@klarna-web-sdk/utils'
import { STORAGE_PREFIX } from '@klarna-web-sdk/utils/src/storage/constants'
import { klarnaIframeStorage } from '@klarna-web-sdk/utils/src/storage/klarnaIframeStorage'

import { EShoppingStorageKeys } from '../constants'

// we need to store the session availability in localStorage to avoid initiating backend bridge unnecessarily
export const SHOPPING_SESSION_KEY = 'shopping-session'
const SESSION_AVAILABLE_KEY = 'isShoppingSessionAvailable'

export class ShoppingSessionBridgeStorage {
  private iframeStorage = klarnaIframeStorage(`${STORAGE_PREFIX}${SHOPPING_SESSION_KEY}`)
  private localStorage = localStorageHelper(SHOPPING_SESSION_KEY)

  async getSessionId(): Promise<string | undefined> {
    return this.iframeStorage.get(EShoppingStorageKeys.ShoppingSessionId) ?? undefined
  }

  async setSessionId(sessionId: string): Promise<void> {
    await this.iframeStorage.set(EShoppingStorageKeys.ShoppingSessionId, sessionId)
    this.localStorage?.set(SESSION_AVAILABLE_KEY, 'true')
  }

  async removeSessionId(): Promise<void> {
    await this.iframeStorage.remove(EShoppingStorageKeys.ShoppingSessionId)
    this.localStorage?.remove(SESSION_AVAILABLE_KEY)
  }

  isSessionAvailable(): boolean {
    return this.localStorage?.get(SESSION_AVAILABLE_KEY) === 'true'
  }
}
